

(function () {
  'use strict';

  /* ── CONFIG ─────────────────────────────────────────────────── */
  const GIFT_WRAP_VARIANT_ID = null; // ← REPLACE with the Variant ID of your
                                      //   "Gift Wrapping" product in Shopify.
                                      //   Leave null to use cart attributes instead.
  const GIFT_WRAP_PRICE_PAISE = 4900; // ₹49 in paise (Shopify uses smallest currency unit)

  /* ── ELEMENT REFS ───────────────────────────────────────────── */
  const $  = id => document.getElementById(id);
  const $$ = sel => document.querySelectorAll(sel);

  const cartItems    = $('zw-cart-items');
  const cartEmpty    = $('zw-cart-empty');
  const orderSummary = $('zw-order-summary');
  const cartCount    = $('zw-cart-count');
  const srAnnounce   = $('zw-sr-announce');

  /* ── HELPERS ─────────────────────────────────────────────────── */

  function announce(msg) {
    if (!srAnnounce) return;
    srAnnounce.textContent = '';
    requestAnimationFrame(() => { srAnnounce.textContent = msg; });
  }

  function formatMoney(paise) {
    // Shopify returns prices in paise (INR subunit)
    const rupees = paise / 100;
    return '₹' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

    /* ── FREE SHIPPING NOTE ──────────────────────────────────────── */
  const FREE_SHIP_PAISE = 149900; // ₹1,499

  function updateShipNote(totalPaise) {
    const text = $('zw-ship-text');
    const fill = $('zw-ship-fill');
    if (!text || !fill) return;
    const gap = FREE_SHIP_PAISE - totalPaise;
    text.innerHTML = gap > 0
      ? 'Add <b>' + formatMoney(gap) + '</b> more for <b>FREE shipping</b> in India'
      : '✓ You\'ve unlocked <b>FREE shipping</b> in India';
    fill.style.width = Math.min(100, (totalPaise / FREE_SHIP_PAISE) * 100) + '%';
  }

  const shipBox = $('zw-ship');
  if (shipBox) updateShipNote(parseInt(shipBox.dataset.total, 10) || 0);

  function setLoading(btn, state) {
    if (!btn) return;
    btn.classList.toggle('loading', state);
    btn.disabled = state;
  }

  /* ── FETCH WRAPPERS ──────────────────────────────────────────── */

  async function cartChange(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('Cart change failed');
    return res.json(); // returns full cart object
  }

  async function cartAdd(variantId, quantity = 1, properties = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    });
    if (!res.ok) throw new Error('Cart add failed');
    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function updateCartAttributes(attributes) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });
    return res.json();
  }

  /* ── UPDATE SUMMARY UI ───────────────────────────────────────── */

  function updateSummaryUI(cart) {
    // item count
    const count = cart.item_count;
    if (cartCount) cartCount.textContent = count + ' ' + (count === 1 ? 'item' : 'items');
    const sumCount = $('zw-sum-count');
    if (sumCount) sumCount.textContent = count;

        // subtotal (before discount)
    const subtotalEl = $('zw-sum-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price);

    // discount row
    const discount  = cart.total_discount || 0;
    const savingRow = $('zw-saving-row');
    const savingEl  = $('zw-sum-saving');
    if (savingEl)  savingEl.textContent = '−' + formatMoney(discount);
    if (savingRow) savingRow.style.display = discount > 0 ? '' : 'none';

    // total
    const totalEl = $('zw-sum-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        const deliveryEl = $('zw-sum-delivery');
        updateShipNote(cart.total_price);
    if (deliveryEl) deliveryEl.textContent = cart.total_price >= 149900 ? 'Free (India)' : '₹59 (India)';

    // empty state toggle
    if (cart.item_count === 0) {
      if (cartItems)    cartItems.innerHTML = '';
      if (cartEmpty)    cartEmpty.style.display = 'flex';
      if (orderSummary) orderSummary.style.display = 'none';
    }
  }

  /* ── UPDATE ITEM ROW UI ──────────────────────────────────────── */

  function updateItemRow(key, cart) {
    const row = document.querySelector(`.cart-item[data-key="${key}"]`);
    if (!row) return;

    const cartItem = cart.items.find(i => i.key === key);
    if (!cartItem) {
      // item was removed (qty → 0)
      row.classList.add('is-removing');
      setTimeout(() => row.remove(), 280);
      return;
    }

    // update qty display
    const qtyNum = row.querySelector('.qty-num');
    if (qtyNum) qtyNum.textContent = cartItem.quantity;

    // update price display
    const priceEl = row.querySelector('.item-price');
    if (priceEl) priceEl.textContent = formatMoney(cartItem.final_line_price);

    // update −/+ button's data-remove attr
    const decBtn = row.querySelector('[data-action="decrease"]');
    if (decBtn) {
      if (cartItem.quantity <= 1) decBtn.dataset.remove = 'true';
      else delete decBtn.dataset.remove;
    }
  }

  /* ── QTY CHANGE ──────────────────────────────────────────────── */

  async function handleQtyChange(btn) {
    const key    = btn.dataset.key;
    const action = btn.dataset.action;
    const row    = btn.closest('.cart-item');
    const qtyNum = row.querySelector('.qty-num');
    const currentQty = parseInt(qtyNum.textContent);

    let newQty;
    if (action === 'increase')  newQty = currentQty + 1;
    else if (action === 'decrease') {
      newQty = btn.dataset.remove === 'true' ? 0 : currentQty - 1;
    }

    // optimistic UI
    if (newQty > 0) qtyNum.textContent = newQty;

    // disable both buttons while request is in flight
    const btns = row.querySelectorAll('.qty-btn');
    btns.forEach(b => setLoading(b, true));

    try {
      const cart = await cartChange(key, newQty);
      updateItemRow(key, cart);
      updateSummaryUI(cart);
      announce(newQty === 0 ? 'Item removed from your bag.' : `Quantity updated to ${newQty}.`);
    } catch (e) {
      // revert optimistic update on error
      qtyNum.textContent = currentQty;
      console.error('[Ziwara Cart]', e);
    } finally {
      btns.forEach(b => setLoading(b, false));
    }
  }

  /* ── REMOVE ──────────────────────────────────────────────────── */

  async function handleRemove(btn) {
    const key = btn.dataset.key;
    const row = btn.closest('.cart-item');
    const productName = row.querySelector('.item-name')?.textContent?.trim() || 'Item';

    setLoading(btn, true);
    try {
      const cart = await cartChange(key, 0);
      row.classList.add('is-removing');
      setTimeout(() => {
        row.remove();
        updateSummaryUI(cart);
      }, 280);
      announce(`${productName} removed from your bag.`);
    } catch (e) {
      setLoading(btn, false);
      console.error('[Ziwara Cart]', e);
    }
  }

  /* ── GIFT WRAP ───────────────────────────────────────────────── */

  const giftToggle = $('zw-gift-toggle');
  if (giftToggle) {
    giftToggle.addEventListener('change', async function () {
      const checked = this.checked;

      if (GIFT_WRAP_VARIANT_ID) {
        // Proper product approach — add/remove actual gift variant
        try {
          if (checked) {
            await cartAdd(GIFT_WRAP_VARIANT_ID, 1, { _gift_wrap: 'yes' });
          } else {
            const cart = await getCart();
            const giftItem = cart.items.find(i => i.variant_id == GIFT_WRAP_VARIANT_ID);
            if (giftItem) await cartChange(giftItem.key, 0);
          }
          const cart = await getCart();
          updateSummaryUI(cart);
        } catch (e) { console.error('[Ziwara Cart Gift Wrap]', e); }
      } else {
        // Fallback: cart attribute (won't add to order price automatically —
        // handle the ₹49 charge via a Shopify Script or manual note)
        try {
          await updateCartAttributes({ gift_wrap: checked ? 'yes' : 'no' });
          // visually update total with ₹49 offset
          const totalEl = $('zw-sum-total');
          const subEl   = $('zw-sum-subtotal');
          if (totalEl && subEl) {
            const cart = await getCart();
            const base = cart.total_price;
            const adjusted = checked ? base + GIFT_WRAP_PRICE_PAISE : base;
            totalEl.textContent  = formatMoney(adjusted);
            subEl.textContent    = formatMoney(adjusted);
          }
          announce(checked ? 'Gift wrapping added (₹49).' : 'Gift wrapping removed.');
        } catch (e) { console.error('[Ziwara Cart Gift Wrap]', e); }
      }
    });
  }

  /* ── PROMO CODE ──────────────────────────────────────────────── */

  const promoApply = $('zw-promo-apply');
  const promoInput = $('zw-promo-input');
  const promoMsg   = $('zw-promo-msg');

    if (promoApply && promoInput) {
    promoApply.addEventListener('click', async () => {
      const code = promoInput.value.trim();
      if (!code) return;

      promoApply.textContent = '...';
      promoApply.disabled = true;
      promoMsg.className = 'promo-msg';
      promoMsg.textContent = '';

      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        if (!res.ok) throw new Error('Discount request failed');
        const cart = await res.json();

        const match = (cart.discount_codes || []).find(
          d => d.code.toLowerCase() === code.toLowerCase()
        );

        if (match && match.applicable && cart.total_discount > 0) {
          await refreshCartItems();
          updateSummaryUI(cart);
          const label = $('zw-saving-label');
          if (label) label.textContent = 'Discount (' + match.code.toUpperCase() + ')';
          promoMsg.className = 'promo-msg ok';
          promoMsg.textContent = '✓ ' + match.code.toUpperCase() + ' applied — you save ' + formatMoney(cart.total_discount) + '.';
          announce('Promo code applied.');
        } else {
          promoMsg.className = 'promo-msg err';
          promoMsg.textContent = "This code isn't valid for the items in your bag.";
        }
      } catch (e) {
        console.error('[Ziwara Cart Promo]', e);
        promoMsg.className = 'promo-msg err';
        promoMsg.textContent = 'Could not apply the code. Please try again.';
      } finally {
        promoApply.textContent = 'Apply';
        promoApply.disabled = false;
      }
    });

    promoInput.addEventListener('keydown', e => {
      if (e.key === 'Enter') promoApply.click();
    });
  }
    /* ── RE-RENDER ITEM LIST (after upsell add) ──────────────────── */
  async function refreshCartItems() {
    try {
      const res = await fetch('/cart?_=' + Date.now(), { headers: { 'Accept': 'text/html' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('zw-cart-items');
      if (fresh && cartItems) cartItems.innerHTML = fresh.innerHTML;
    } catch (e) { console.error('[Ziwara Cart refresh]', e); }
  }

  /* ── UPSELL ADD TO BAG ───────────────────────────────────────── */

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-action="upsell-add"]');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      await cartAdd(variantId, 1);
      btn.textContent = '✓ Added!';
      btn.style.background    = 'var(--emerald)';
      btn.style.color         = 'var(--cream)';
      btn.style.borderColor   = 'var(--emerald)';

            const cart = await getCart();
      await refreshCartItems();
      updateSummaryUI(cart);
      document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
      announce('Item added to your bag.');

      setTimeout(() => {
        btn.textContent          = originalText;
        btn.disabled             = false;
        btn.style.background     = '';
        btn.style.color          = '';
        btn.style.borderColor    = '';
      }, 2000);
    } catch (e) {
      btn.textContent = originalText;
      btn.disabled    = false;
      console.error('[Ziwara Cart Upsell]', e);
    }
  });

  /* ── EVENT DELEGATION — qty & remove ────────────────────────── */

  if (cartItems) {
    cartItems.addEventListener('click', function (e) {
      const btn = e.target.closest('button[data-action]');
      if (!btn) return;

      const action = btn.dataset.action;
      if (action === 'increase' || action === 'decrease') handleQtyChange(btn);
      if (action === 'remove') handleRemove(btn);
    });
  }

})();
